import {defineMessages} from 'react-intl'

export const reviewMessages = defineMessages({
  reviewSectionTranslate: {
    id: 'reviewSectionTranslate',
    defaultMessage: 'Translate'
  },
  reviewSectionTranslating: {
    id: 'reviewSectionTranslating',
    defaultMessage: 'Loading translation...'
  },
  reviewSectionTranslated: {
    id: 'reviewSectionTranslated',
    defaultMessage: 'Translated by Google'
  },
  reviewSectionOriginal: {
    id: 'reviewSectionOriginal',
    defaultMessage: 'Show original'
  },
  reviewSectionNoResultsTitle: {
    id: 'selectorList.noResultsDescription',
    defaultMessage: 'We found no matches'
  },
  reviewSectionNoResultsDescription: {
    id: 'reviewSectionNoResultsDescription',
    defaultMessage: 'Try adjusting your search to see more reviews.'
  },
  reviewSectionSearchPlaceholder: {
    id: 'reviewSectionSearchPlaceholder',
    defaultMessage: 'Search in reviews'
  },
  reviewSectionCount: {
    id: 'reviewSectionCount',
    defaultMessage: '{count, plural, one {1 result} other {# results}}'
  },
  guestReviews: {
    id: 'reviews.guestReviews',
    defaultMessage: 'Guest reviews'
  },
  basedOnReviews: {
    id: 'reviews.basedOnReviews',
    defaultMessage:
      '{reviewsCount, plural, one {Based on 1 verified review} other {Based on # verified reviews}}'
  },
  basedOnNoReviews: {
    id: 'reviews.basedOnNoReviews',
    defaultMessage: 'Based on verified reviews'
  },
  stayedNights: {
    id: 'reviews.stayedNights',
    defaultMessage: '{nightsCount, plural, one {1 night} other {# nights}}'
  },
  noReviewsTitle: {
    id: 'reviews.noReviewsTitle',
    defaultMessage: 'No written reviews'
  },
  noReviewsDescription: {
    id: 'reviews.noReviewsDescription',
    defaultMessage: 'Guests have not written any reviews for this property yet.'
  },
  guestReviewsTitle: {
    id: 'guestReviews',
    defaultMessage: 'What guests say'
  },
  reviews: {
    id: 'reviews',
    defaultMessage: 'Reviews'
  }
})
